'use client';
import { Suspense } from 'react';

import { HomeGameSectionsContent } from './home-game-sections-content';
import { HomeGameSectionsSearchSwitch } from './home-game-sections-search-switch';
import type { HomeGameSectionsProps } from './home-game-sections-types';

const HomeGameSections = ({
  initialHomeGames,
  openNotAllowedModal,
}: HomeGameSectionsProps) => {
  const defaultContent = (
    <HomeGameSectionsContent
      initialHomeGames={initialHomeGames}
      openNotAllowedModal={openNotAllowedModal}
    />
  );

  return (
    <Suspense fallback={defaultContent}>
      <HomeGameSectionsSearchSwitch
        openNotAllowedModal={openNotAllowedModal}
        defaultContent={defaultContent}
      />
    </Suspense>
  );
};

export { HomeGameSections };
